import React from 'react';
import { motion } from 'framer-motion';
import { Users, TrendingUp } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const CounsellingImpactChart = ({ counsellingAnalysis }) => {
  if (!counsellingAnalysis || counsellingAnalysis.totalSessions === 0) {
    return null;
  }

  const { totalSessions, sessionFrequency, counsellingImpact } = counsellingAnalysis;

  // Generate mock before/after data
  const impactData = [
    { period: 'Before', behavioral: 60, academic: 55 },
    { period: 'After', behavioral: counsellingImpact.behavioralImprovement, academic: counsellingImpact.academicImprovement }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6"
    >
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="p-3 bg-violet-600 rounded-lg">
          <Users className="h-6 w-6 text-white" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">Counselling Impact</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">{totalSessions} sessions completed</p>
        </div>
      </div>

      {/* Impact Chart */}
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={impactData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="period" tick={{ fill: '#6b7280' }} />
          <YAxis tick={{ fill: '#6b7280' }} />
          <Tooltip
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              border: 'none',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Legend />
          <Line type="monotone" dataKey="behavioral" stroke="#8b5cf6" strokeWidth={3} name="Behavioral" />
          <Line type="monotone" dataKey="academic" stroke="#3b82f6" strokeWidth={3} name="Academic" />
        </LineChart>
      </ResponsiveContainer>
    </motion.div>
  );
};

export default CounsellingImpactChart;
